import { oc } from '@orpc/contract';
import { revokeUserSessionsInputSchema, revokeUserSessionsOutputSchema } from '../schemas/users.schemas.js';
export const revokeUserSessionsContract = oc
    .route({
    method: 'POST',
    path: '/users/{id}/revoke-sessions',
    tags: ['Users'],
    summary: 'Sign a user out of every device: their refresh tokens stop working at once (ADMIN)',
})
    .input(revokeUserSessionsInputSchema)
    .output(revokeUserSessionsOutputSchema);
//# sourceMappingURL=revoke-user-sessions.contract.js.map